import React, { Component } from "react";
import code_app from "images/index/code-app.png";
import code_wechat from "images/index/code-wechat.png";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { Select } from 'element-react';
import Footer from '../Footer';

require("./index.scss");

class GlobalFooter extends Component {
  // export default class GlobalFooter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      codeImg: []
    };

  }

  componentDidMount() {
    // this.getQrcodeInfo()
    // this.getPagehomeBottonInfo()
    // debugger;
    window.addEventListener("message", function (event) {
      // alert('message')
      // console.log('event111234444',event)
      // if (event.origin !== 'http://tyjrswt.nmg.gov.cn/fwdt/index_8200.html') return;
      // var _iframe = document.getElementById('iframe').contentWindow.document.getElementsByClassName('list');
    });
    // window.onload = function(){
    //   var _iframe = document.getElementById('iframe').contentWindow.document.getElementsByClassName('list');
    //   _iframe.style.bottom = "auto";  //修改样式
    //   _iframe.style.top= "28px"; 
    //   _iframe.style.maxHeight= "180px"; 
    //   _iframe.style.padding= "10px 50px";
    // }
  }

  getQrcodeInfo() {
    return Http.get(Request.getQrcodeInfo(), {}, obj => {
      if (obj && obj.code == 200) {
        this.setState({
          codeImg: obj.data[0].banner
        })
      }
    });
  }

  getPagehomeBottonInfo() {
    return Http.get(Request.getPagehomeBottonInfo(), {}, obj => {
      if (obj && obj.code == 200) {
        this.setState({
          data: obj.data[0].childrens
        })
      }
    });
  }

  render() {
    let { data, codeImg } = this.state;
    let tmp = [];
    if (data && data[8]) {
      tmp = JSON.parse(JSON.stringify(data[8]));
    }
  

    return (
      <div >
        <Footer />
        {/* <iframe
          id="iframe"
          width="100%"
          height="300"
          frameBorder="0"
          allowFullScreen={true}
          src="http://tyjrswt.nmg.gov.cn/fwdt/index_8200.html"
        >   
        </iframe> */}
        {/* <footer className="footer-wrapper"> */}
        {/* {data.length != 0 && tmp ? */}
        {/* {1?//因为data是[]没数据，暂时放开条件判断
          <div className="container"> */}

            {/* <div className="footer_links">
              {tmp.childrens.reverse().map((data, index) => {
                return (
                  <Select key={index} placeholder={data.name} className="footer_links_dropDown" onChange={(value) => { window.open(value) }}>
                    {data.setting.map((itemData, i) => {
                      return <Select.Option key={i} label={itemData.settingKey} value={itemData.settingValue != undefined && itemData.settingValue != '' ? itemData.settingValue : null} />
                    })}
                  </Select>
                )
              })}
            </div> */}

            {/* <div className="footer-content">             
              <div className="l-content">
                <div className="foot-img"></div>
                <div className="foot-link">
                  <div><a href="" >关于我们</a></div>
                  <div><a href="" >加入收藏</a></div>
                  <div><a href="" >网站地图</a></div>
                  <div><a href="" >站长统计</a></div>
                </div>
              </div>
              <div className="c-content">
                <div>主办单位：内蒙古自治区退役军人事务厅<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>          承办单位：内蒙古自治区退役军人服务中心</div>
                <div><a href="" style={{ "color": "#fff" }}>蒙ICP备19002071</a><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>蒙公网安备 15010202150834号</span><span className="gongan"> 网站标识码1500000090</span></div>
                <div>本网站发布的所有信息均不收取任何费用如遇到任何以本网站名义收取费用的情况请向自治区政府办公厅纪检部门举报</div>
              </div>
              <div className="r-content">
                <div className="qr-code"></div>
                <div className="qr-txt">微信二维码或客户端</div>
              </div>
            </div>
          </div>
          : null}
        </footer> */}
      </div>
    );
  }
}

export default GlobalFooter;
